import { render, staticRenderFns } from "./Packagings.vue?vue&type=template&id=de03d662&"
import script from "./Packagings.vue?vue&type=script&lang=js&"
export * from "./Packagings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports